export const listIngredients = /* GraphQL */ `
  query ListIngredients($userId: ID!) {
    listIngredients(userId: $userId) {
      userId
      ingredientId
      name
      brand
      strain
      varietal
      thc
      thca
      cbd
      cbda
      cbg
      cbn
      createdAt
      updatedAt
    }
  }
`;

export const getIngredient = /* GraphQL */ `
  query GetIngredient($userId: ID!, $ingredientId: ID!) {
    getIngredient(userId: $userId, ingredientId: $ingredientId) {
      userId
      ingredientId
      name
      brand
      strain
      varietal
      thc
      thca
      cbd
      cbda
      cbg
      cbn
      createdAt
      updatedAt
    }
  }
`;

export const createIngredient = /* GraphQL */ `
  mutation CreateIngredient($input: CreateIngredientInput!) {
    createIngredient(input: $input) {
      userId
      ingredientId
      name
      brand
      strain
      varietal
      thc
      thca
      cbd
      cbda
      cbg
      cbn
      createdAt
      updatedAt
    }
  }
`;

export const updateIngredient = /* GraphQL */ `
  mutation UpdateIngredient($input: UpdateIngredientInput!) {
    updateIngredient(input: $input) {
      userId
      ingredientId
      name
      brand
      strain
      varietal
      thc
      thca
      cbd
      cbda
      cbg
      cbn
      createdAt
      updatedAt
    }
  }
`;

export const deleteIngredient = /* GraphQL */ `
  mutation DeleteIngredient($input: DeleteIngredientInput!) {
    deleteIngredient(input: $input) {
      userId
      ingredientId
      name
      brand
      strain
      varietal
      thc
      thca
      cbd
      cbda
      cbg
      cbn
      createdAt
      updatedAt
    }
  }
`;

export const lookupLucidGreenProduct = /* GraphQL */ `
  mutation LookupLucidGreenProduct($lucidId: String!) {
    lookupLucidGreenProduct(lucidId: $lucidId) {
      productName
      brand
      strain
      varietal
      thc
      thca
      cbd
      cbda
      cbg
      cbn
    }
  }
`;
